// regex sanitization is fine for out usage since we don't render HTML
// isomorphic-dompurify could be used in the future to outsource the sanitization

// 50-char limit matches the max length enforced on the Task Reference field
export const sanitizeSearchParam = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined
  const sanitized = value
    .replace(/<[^>]*>/g, '')
    .trim()
    .slice(0, 50)
  return sanitized || undefined
}
